export const UI_SETTING_IS_OLD_ORDER_FORM_CART_MODE = 'order_form_cart_v1'
export const UI_SETTING_COLOR_SCHEME = 'ui_partner_color_scheme'

export const UI_SETTINGS_DEFAULT_COLOR_SCHEME = 'light'

export const UI_SETTINGS_COLOR_SCHEMES = [
  {
    label: 'Светлая',
    value: 'light'
  },
  {
    label: 'Тёмная',
    value: 'dark'
  },
  {
    label: 'Контрастная',
    value: 'high-contrast'
  }
]
